// extracted by mini-css-extract-plugin
export default {"tooltip":"tX-z","arrow":"uX-z"};